import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Child = JSX.Element | string | null;

type Props = {
  children: Child[] | Child;
  collapsible?: boolean;
};

const Paragraph = ({ children, collapsible = false }: Props) => {
  const { t } = useTranslation();

  const [collapsed, setCollapsed] = useState(collapsible);

  return (
    <div
      className={`inline gap-1 ${collapsible ? 'cursor-pointer' : ''}`}
      onClick={() => {
        if (collapsible) {
          setCollapsed(!collapsed);
        }
      }}
    >
      <p
        className={`text-left text-base leading-normal ${collapsed ? 'line-clamp-2' : ''}`}
      >
        {children}
        {!collapsed && collapsible && (
          <span className="ml-1 font-semibold underline">{t('readLess')}</span>
        )}
      </p>
    </div>
  );
};

export default Paragraph;
